import { Image, ImageProps } from 'components'
import { useExplorerConfig } from '../providers'

export interface Props extends ImageProps {
  mediaId: string
}

export default function MediaImage({ mediaId, height, width, ...rest }: Props) {
  const { templateDocs } = useExplorerConfig()
  const media = templateDocs?.media.find(m => m.id === mediaId)
  if (!media) return null

  let _height = height || width ? 'auto' : '100%'
  let _width = width || height ? 'auto' : '100%'

  return (
    <Image
      draggable={false}
      height={_height}
      width={_width}
      objectFit="contain"
      src={media.url}
      {...rest}
    />
  )
}
